<template>
  <drag-drawer v-model="showDrawer"
               :width.sync="width"
               :min-width="minWidth"
               :inner="true"
               :transfer="false"
               :placement="placementComputed"
               :draggable="true"
               @on-resize="handleResize"
               @on-close="handleClose"
               :scrollable="true">
    <div slot="header">
      <label>{{title}}</label>
    </div>
    <!--top-->
    <div>
      <el-input placeholder="文件名称" v-model="searchValue" class="input-with-select">
        <el-button type="primary" slot="append" icon="el-icon-search" @click="searchData"></el-button>
      </el-input>
      <span style="float:right;">
          <el-button type="primary" @click="handleAddFile">新增语音文件</el-button>
        </span>
    </div>
    <!--table-->
    <div>
      <el-table
        :data="fileData"
        style="width: 100%;text-align: center;"
      >
        <el-table-column
          :show-overflow-tooltip="showTooltip"
          property="voiceFileName"
          label="文件名称">
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="showTooltip"
          property="remark"
          label="语音文件备注">
        </el-table-column>
        <el-table-column
          width="220"
          label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="editVoiceFile(scope.row.id,scope.row.voiceFileName,scope.row.voiceFileRoute,scope.row.remark)"
              v-if="roleList['3_5-4-2']">编辑</el-button>
            <el-button
              size="mini"
              v-if="roleList['3_5-4-4']"
              @click="playVoiceFile(scope.row.voiceFileRoute)">播放</el-button>
            <el-button
              v-if="roleList['3_5-4-3']"
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index,scope.row)">删除</el-button>
          </template>
        </el-table-column>

      </el-table>
    </div>
    <playMusicPop  @closeRecordfile="closeRecordfile" :showRecordFile="showRecordFile" :recordFile="recordFile"></playMusicPop>
    <voiceFileEditOrAdd  @closeVoiceFileEditOrAdd="closeVoiceFileEditOrAdd" :showVoiceFileEditOrAdd="showVoiceFileEditOrAdd" :remark="remark" :fileId="fileId" :fileName="fileName" :fileRoute="fileRoute"></voiceFileEditOrAdd>
  </drag-drawer>
</template>

<script>
  import playMusicPop from '@/components/statisticsReportForm/detailedReportForm/PlayMusicPop.vue'
  import DragDrawer from "@/components/flow/components/dragDrawer/drag-drawer";
  import voiceFileEditOrAdd from '@/components/systemSetup/CTIConfigure/VoiceFileEditOrAdd.vue'
  export default {
    name: "FileDrawer",
    components: {playMusicPop,DragDrawer,voiceFileEditOrAdd},
    props: ["flowId","file"],
    data() {
      return {
        showTooltip:true,
        roleList: JSON.parse(localStorage.getItem("roleList")),
        fileRoute:'',
        fileName:'',
        width: 600,
        minWidth: 600,
        title: '语音文件',
        placement: 'right',
        showDrawer: false,
        searchValue: '',
        fileId: null,
        fileData: [],
        showDialog: false,
        isEdit: false,
        fId:'',
        recordFile:'',
        showRecordFile: false,
        showVoiceFileEditOrAdd:false,
        remark:'',
      }
    },
    methods:{
      //编辑语音文件
      editVoiceFile:function (id,voiceFileName,voiceFileRoute,remark) {
        this.showVoiceFileEditOrAdd=true;
        this.fileId=id;
        this.fileName=voiceFileName;
        this.fileRoute=voiceFileRoute;
        this.remark = remark;
      },
      //播放回调函数
      closeRecordfile:function(){
        this.showRecordFile=false;
      },
      //在线播放语音文件
      playVoiceFile:function (recordFile) {
        if(!recordFile){
          this.$Modal.info({
            title:'提示',
            content:"语音文件不存在"
          });
          return false;
        }
        this.showRecordFile=true;
        this.recordFile=this.baseImgURL+recordFile;
      },
      closeVoiceFileEditOrAdd:function(flag){
        this.showVoiceFileEditOrAdd=false;
        if(flag){
          this.initData();
        }
      },
      initData() {
        let that = this
        let param={
          voiceFileName:this.searchValue,
          journalType:"系统管理=>CTI配置=>语音文件查询",
          menuId:"null",
        };
        this.$http.post('voiceFile/toIndex.json',param).then(res=>{
          let response = res.data
          if (response.flag != '666') {
            that.$alert(response.msg,'提示',{
              confirmButtonText: '确定'
            })
            return false
          }
          if(response.obj.list.content){
            this.fileData = response.obj.list.content;
          }
        })
      },
      searchData() {
        this.initData()
      },
      handleResize(event) {
        const {atMin} = event
        console.log(atMin)
      },
      handleClose(val) {
        this.$emit('closeDrawer', true)
      },
      handleAddFile() {
        //添加语音文件
        this.showVoiceFileEditOrAdd=true;
        this.fileId="";
        this.fileName="";
        this.fileRoute="";
        this.remark="";
      },
      handleDelete(index, row) {
        let that=this;
        let param={
          id:row.id,
          journalType:"CTI配置=>语音文件=>删除",
          menuId:"3_5-5-3"
        };
        this.$Modal.confirm({
          title: '提示',
          content: "是否确定删除",
          onOk: () => {
            that.$http.post("voiceFile/doDelete.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$alert(res.data.msg, '提示', {
                  confirmButtonText: '确定'
                });
                return false;
              }
              that.$Message.info("语音文件删除成功");
              that.initData();
            });
          }
        });
      },
      handleCloseDialog(val) {
        this.showDialog = val
        if (!val) {
          this.initData();
        }
      }
    },
    computed: {
      placementComputed() {
        return this.placement ? 'left' : 'right'
      }
    },
    watch:{
      file:{
        deep:true,
        immediate:true,
        handler(val) {
          if (val) {
            this.showDrawer = true
              this.initData()
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/CTIConfigure/IvrFileDrawer.vue